import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const LoginLazy = lazyLoader(
  () => import('./Login' /* webpackChunkName: "login" */),
);

const Login = () => {
  return (
    <Suspense fallback={null}>
      <LoginLazy />
    </Suspense>
  );
};

export default Login;
